<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">Shipment</h4>
        </div>
        <div id="accordion2" class="accordion" role="tablist" aria-multiselectable="true">
            <div class="card">
                <div class="card-header" role="tab" id="headingOne">
                    <h5 class="mb-0">
                        <a data-toggle="collapse" data-parent="#accordion2" href="#collapse1" aria-expanded="true" aria-controls="collapseOne">
                            Leg #1
                        </a>
                    </h5>
                </div>
                <div id="collapse1" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                    <div class="profiletimeline">
                        <div class="sl-item">
                            <div class="sl-left"><i class="fas fa-plane fa-2x"></i></div>
                            <div class="sl-right">
                                <div>
                                    <a href="javascript:void(0)">Mumbai, India</a>
                                    <p class="date">Yesterday at 06:00 am</p>
                                    <div class="row">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>Ship Date</th>
                                                <th>Expected Arrival</th>
                                                <th>Actual Arrival</th>
                                                <th>Container</th>
                                                <th>Container Type</th>
                                                <th>Expected Weight</th>
                                                <th>Actual Weight</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Jun 20, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>321654987</td>
                                                <td>Freight Container</td>
                                                <td>10,000 Kg</td>
                                                <td>10,000 Kg</td>
                                            </tr>
                                            <tr>
                                                <td>Jun 20, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>321654987</td>
                                                <td>Freight Container</td>
                                                <td>10,000 Kg</td>
                                                <td>10,000 Kg</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sl-item">
                            <div class="sl-left"><i class="fas fa-plane fa-2x"></i></div>
                            <div class="sl-right">
                                <div>
                                    <a href="javascript:void(0)">Calgary, Alberta</a>
                                    <p class="date">Yesterday at 06:00 am</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="headingTwo">
                    <h5 class="mb-0">
                        <a class="collapsed" data-toggle="collapse" data-parent="#accordion2" href="#collapse2" aria-expanded="false" aria-controls="collapseTwo">
                            Leg #2
                        </a>
                    </h5>
                </div>
                <div id="collapse2" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
                    <div class="profiletimeline">
                        <div class="sl-item">
                            <div class="sl-left"><i class="fas fa-plane fa-2x"></i></div>
                            <div class="sl-right">
                                <div>
                                    <a href="javascript:void(0)">Mumbai, India</a>
                                    <p class="date">Yesterday at 06:00 am</p>
                                    <div class="row">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>Ship Date</th>
                                                <th>Expected Arrival</th>
                                                <th>Actual Arrival</th>
                                                <th>Container</th>
                                                <th>Container Type</th>
                                                <th>Expected Weight</th>
                                                <th>Actual Weight</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Jun 20, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>321654987</td>
                                                <td>Freight Container</td>
                                                <td>10,000 Kg</td>
                                                <td>10,000 Kg</td>
                                            </tr>
                                            <tr>
                                                <td>Jun 20, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>321654987</td>
                                                <td>Freight Container</td>
                                                <td>10,000 Kg</td>
                                                <td>10,000 Kg</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sl-item">
                            <div class="sl-left"><i class="fas fa-plane fa-2x"></i></div>
                            <div class="sl-right">
                                <div>
                                    <a href="javascript:void(0)">Calgary, Alberta</a>
                                    <p class="date">Yesterday at 06:00 am</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="headingThree">
                    <h5 class="mb-0">
                        <a class="collapsed" data-toggle="collapse" data-parent="#accordion2" href="#collapse3" aria-expanded="false" aria-controls="collapseThree">
                            Leg #3
                        </a>
                    </h5>
                </div>
                <div id="collapse3" class="collapse" role="tabpanel" aria-labelledby="headingThree">
                    <div class="profiletimeline">
                        <div class="sl-item">
                            <div class="sl-left"><i class="fas fa-plane fa-2x"></i></div>
                            <div class="sl-right">
                                <div>
                                    <a href="javascript:void(0)">Mumbai, India</a>
                                    <p class="date">Yesterday at 06:00 am</p>
                                    <div class="row">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>Ship Date</th>
                                                <th>Expected Arrival</th>
                                                <th>Actual Arrival</th>
                                                <th>Container</th>
                                                <th>Container Type</th>
                                                <th>Expected Weight</th>
                                                <th>Actual Weight</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Jun 20, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>321654987</td>
                                                <td>Freight Container</td>
                                                <td>10,000 Kg</td>
                                                <td>10,000 Kg</td>
                                            </tr>
                                            <tr>
                                                <td>Jun 20, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>Oct 1, 2018</td>
                                                <td>321654987</td>
                                                <td>Freight Container</td>
                                                <td>10,000 Kg</td>
                                                <td>10,000 Kg</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sl-item">
                            <div class="sl-left"><i class="fas fa-plane fa-2x"></i></div>
                            <div class="sl-right">
                                <div>
                                    <a href="javascript:void(0)">Calgary, Alberta</a>
                                    <p class="date">Yesterday at 06:00 am</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TradeDocuments",
        props: {
            tradeid: String,
            trade: Object,
            events: Object
        }
    }
</script>

<style scoped>
</style>
